import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {GetProvidersDetailsMedicalGuideModel} from 'domain/usecases';
import {UseHealthProviderDetailsQueryParams} from './types';
import {getHealthProviderDetails} from '../../services/getHealthProviderDetails';

export function useHealthProviderDetailsQuery(params: UseHealthProviderDetailsQueryParams) {
	const {enabled = true, ...queryParams} = params;

	const shouldFetchProviderDetails =
		enabled &&
		Boolean(
			queryParams.cdUf &&
			queryParams.nmCidade &&
			queryParams.cdPrestador &&
			queryParams.dsTipo &&
			queryParams.cdRedeHap,
		);

	const {data, isLoading, isError} = useQuery<GetProvidersDetailsMedicalGuideModel>({
		queryKey: [QUERY_KEYS.HEALTH_PROVIDER_DETAILS_GUIDE, queryParams],
		queryFn: ({signal}) => getHealthProviderDetails({...queryParams, signal}),
		enabled: shouldFetchProviderDetails,
	});

	return {
		data,
		isLoading,
		isError,
	};
}
